interface SyncbakResponse {
  SUCCESS: string;
  MVPD_LOGO_URL: string;
  CHANNEL?: { name: string };
  ERROR_CODE?: string;
}

export default (response: SyncbakResponse) => {
  const { SUCCESS, MVPD_LOGO_URL, CHANNEL, ERROR_CODE } = response;

  return {
    streamUrl: SUCCESS,
    mvpdLogoUrl: MVPD_LOGO_URL,
    stationCode: CHANNEL?.name,
    errorCode: ERROR_CODE,
  };
};
